import { Link } from "react-router-dom";

const CONTENT = {
  templates: {
    title: "Template messages",
    phase: 2,
    blurb: "Sync your approved WhatsApp templates from Meta, submit new ones for approval, and send them from the inbox — including to customers whose 24-hour window has closed.",
    items: [
      "One-click sync of templates from your WhatsApp Business Account (status: approved / pending / rejected)",
      "Create & submit templates: header, body with variables, footer, buttons",
      "Template picker in the composer with variable inputs and live preview",
    ],
  },
  broadcasts: {
    title: "Broadcast campaigns",
    phase: 3,
    blurb: "Send an approved template to a segment of leads, contacts or clients — rate-limited, retried, and tracked per recipient.",
    items: [
      "Audience from Leads / Contacts / Clients filters or a CSV upload",
      "Merge fields like {{lead.name}} mapped into template variables",
      "Schedule now or later; pause, resume, cancel",
      "Per-recipient delivery: sent · delivered · read · failed · replied, with STOP opt-out handling",
    ],
  },
  flows: {
    title: "Flow builder",
    phase: 4,
    blurb: "Automate replies and routing: keyword triggers, questions that save answers to the lead, buttons and lists, assignment and tagging — with branching.",
    items: [
      "Triggers: keyword match, first message, no agent reply in N minutes, outside business hours",
      "Steps: send text / template / buttons / list, ask & save to a lead field, assign, tag, create lead, wait, branch",
      "Per-business flows with enable/disable and a run log",
    ],
  },
  billing: {
    title: "Billing & usage",
    phase: 2,
    blurb: "See exactly what WhatsApp is costing you: conversations by category (marketing, utility, authentication, service), billable vs free, per number, per period.",
    items: [
      "Live usage captured from Meta's status webhooks (pricing category + billable flag)",
      "Historical backfill from existing delivery logs",
      "Daily / weekly / monthly breakdown, per-number split, CSV export, optional rate card to estimate spend",
    ],
  },
};

export default function WhatsAppPlaceholder({ tab }) {
  const c = CONTENT[tab];
  if (!c) return null;
  return (
    <div className="rounded-2xl border border-dashed border-slate-300 bg-white px-6 py-12 text-center">
      <span className="inline-flex rounded-full bg-slate-100 px-3 py-1 text-[11px] font-semibold uppercase tracking-wide text-slate-600">
        Planned · Phase {c.phase}
      </span>
      <h2 className="mt-4 text-lg font-semibold text-slate-900">{c.title}</h2>
      <p className="mx-auto mt-2 max-w-xl text-sm leading-relaxed text-slate-500">{c.blurb}</p>
      <ul className="mx-auto mt-5 max-w-lg space-y-1.5 text-left text-sm text-slate-600">
        {c.items.map((it) => (
          <li key={it} className="flex gap-2"><span className="mt-2 h-1 w-1 shrink-0 rounded-full bg-slate-400" />{it}</li>
        ))}
      </ul>
      <p className="mt-6 text-xs text-slate-400">
        The <Link to="/whatsapp" className="font-medium text-emerald-700 hover:underline">Inbox</Link> is live now.
      </p>
    </div>
  );
}
